import type { RouteRecordRaw } from 'vue-router'
import MgLayouts from '@/mgLayouts/index.vue'
import MemberRoute from './member'
import ProjectRoute from './project'
import InvestRoute from './invest'
import RecruitRoute from './recruit'
import MyRoute from './my'
import CommunityRoute from './community'

// 中台路由
export const MgRoute: Array<RouteRecordRaw> = [
  {
    path: '/middleGround',
    name: 'MgLayouts',
    component: MgLayouts,
    children: [...MemberRoute, ...ProjectRoute, ...InvestRoute, ...RecruitRoute,...MyRoute, ...CommunityRoute]
  },
]

export default MgRoute